<template>
  <v-app>
    <NavBar v-if="showNavDrawer"/>
    <router-view />
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import "@/store/index.js";
import NavBar from "@/pages/NavBar.vue";

export default {
  name: 'App',
  components: {
    NavBar,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'isLoggedIn', 
    ]),
    ...mapState(['auth']),
    
    showNavDrawer() {
      const path = this.$route.path.toLowerCase()
      return ['/dashboard', '/analytics', '/profile', '/prompts', '/settings'].some(
        (route) => path === route || path.startsWith(`${route}/`)
      )
    },
  },
  methods: {
    ...mapActions([
      "loginUserWithToken",
      "fetchReviewEntities",
    ]),
  },
  async created() {
    const authToken = localStorage.getItem('auth_token')
    if (authToken) {
      try {
        // First authenticate
        await this.$store.dispatch('loginUserWithToken', { auth_token: authToken })
        
        // Fetch review entities for navbar state
        await this.$store.dispatch('fetchReviewEntities')
      } catch (error) {
        console.error('Error during app initialization:', error)
      }
    }
  },
  watch: {
    // Fetch review entities when user logs in
    isLoggedIn(newValue) {
      if (newValue) {
        this.$store.dispatch('fetchReviewEntities').catch(error => {
          console.error('Failed to fetch review entities after login:', error)
        })
      } else {
        // Clear review entities when user logs out
        this.$store.commit('setReviewEntities', [])
      }
    }
  }
}
</script>
